import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
})

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// http.interceptors.response.use(
//   (res) => {
//     return Promise.resolve(res.data)
//   },
//   (err) => {
//     return Promise.reject(err)
//   }
// )

export default http
